import type { DarkOffering } from "@/data/types";

export function OfferingGrid({
  offerings,
  onSelect,
  disabledIds,
  disabledLabel = "Already active",
  selectedId,
  showWealth = false,
}: {
  offerings: DarkOffering[];
  onSelect: (id: number) => void;
  disabledIds?: Set<number>;
  disabledLabel?: string;
  selectedId?: number;
  showWealth?: boolean;
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
      {offerings.map((o) => {
        const disabled = disabledIds?.has(o.id) ?? false;
        const selected = selectedId === o.id;
        const hasWealthPenalty =
          showWealth &&
          o.effects.some(
            (e) =>
              e.type === "wealthLevel" &&
              (e as { type: "wealthLevel"; value: number }).value < 0
          );
        return (
          <button
            key={o.id}
            disabled={disabled}
            onClick={() => onSelect(o.id)}
            className={`text-left rounded-md border p-2.5 transition-colors w-full ${
              disabled
                ? "opacity-40 cursor-not-allowed"
                : selected
                  ? "border-primary bg-primary/10 cursor-pointer"
                  : "hover:border-primary hover:bg-accent cursor-pointer"
            }`}
          >
            <div className="flex items-start gap-1.5">
              <span className="text-[10px] text-muted-foreground font-mono shrink-0 mt-0.5 w-5 text-right">
                {o.id}.
              </span>
              <div className="min-w-0">
                <div className="font-semibold text-xs leading-tight">
                  {o.name}
                  {hasWealthPenalty && (
                    <span className="ml-1 text-yellow-600 dark:text-yellow-400">
                      ⚠
                    </span>
                  )}
                </div>
                {disabled && (
                  <p className="text-[10px] text-muted-foreground mt-0.5 italic">
                    {disabledLabel}
                  </p>
                )}
                <p className="text-[11px] text-muted-foreground mt-0.5 leading-snug line-clamp-3">
                  {o.description}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
